module.exports = __webpack_public_path__ + "static/logotxt-a37dacf32cd3f294609e2dac933d48fd.png";